<section class="login-background">
  <app-pattern></app-pattern>
  <mat-card appearance="outlined" class="login-card">
    <app-compact-header></app-compact-header>
    <div class="heading-5">{{ 'general.api_role_switching_title' | translate }}</div>
    <mat-spinner [diameter]="32"></mat-spinner>
    <div class="align-center version">
      {{ viewService.version }}<ng-container *ngIf="!!viewService.conf.environment"> | {{ viewService.conf.environment }}</ng-container>
    </div>
  </mat-card>
</section>
